<div class="all-product-skeleton">
  <div class="-skeleton-head">
    <wp-skeleton height="54px" [width]="'280px'" [loading]="true" class="-title"></wp-skeleton>
    <wp-skeleton height="54px" [width]="'100%'" [loading]="true" class="-search"></wp-skeleton>
  </div>

  <div class="-skeleton-body">
    <aside class="-skeleton-sidebar">
      <wp-skeleton height="36px" [width]="'160px'" [loading]="true" class="-sidebar-title"></wp-skeleton>
      <wp-skeleton height="26px" [width]="'220px'" [loading]="true" class="-sidebar-top-item"></wp-skeleton>

      <div class="-sidebar-group">
        <wp-skeleton height="30px" [width]="'170px'" [loading]="true" class="-group-title"></wp-skeleton>
        <wp-skeleton height="22px" [width]="'140px'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="22px" [width]="'128px'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="22px" [width]="'154px'" [loading]="true"></wp-skeleton>
      </div>

      <div class="-sidebar-group">
        <wp-skeleton height="30px" [width]="'210px'" [loading]="true" class="-group-title"></wp-skeleton>
        <wp-skeleton height="22px" [width]="'190px'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="22px" [width]="'170px'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="22px" [width]="'120px'" [loading]="true"></wp-skeleton>
      </div>

      <wp-skeleton height="220px" [width]="'100%'" [loading]="true" class="-sidebar-box"></wp-skeleton>
    </aside>

    <section class="-skeleton-content">
      <div class="-skeleton-filters">
        <wp-skeleton height="58px" [width]="'100%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="58px" [width]="'100%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="58px" [width]="'100%'" [loading]="true"></wp-skeleton>
      </div>

      <div class="-skeleton-results-head">
        <wp-skeleton height="12px" [width]="'120px'" [loading]="true"></wp-skeleton>
      </div>

      <div class="-skeleton-cards">
        @for (i of [1, 2, 3, 4, 5, 6]; track i) {
        <article class="-skeleton-card">
          <wp-skeleton height="40px" [width]="'52%'" [loading]="true" class="-card-title"></wp-skeleton>
          <wp-skeleton height="20px" [width]="'100%'" [loading]="true"></wp-skeleton>
          <wp-skeleton height="20px" [width]="'96%'" [loading]="true"></wp-skeleton>
          <wp-skeleton height="20px" [width]="'76%'" [loading]="true"></wp-skeleton>

          <div class="-skeleton-tags">
            <wp-skeleton height="38px" [width]="'44px'" [loading]="true"></wp-skeleton>
            <wp-skeleton height="38px" [width]="'220px'" [loading]="true"></wp-skeleton>
            <wp-skeleton height="38px" [width]="'120px'" [loading]="true"></wp-skeleton>
          </div>
          <wp-skeleton height="38px" [width]="'320px'" [loading]="true"></wp-skeleton>
        </article>
        }
      </div>
    </section>
  </div>
</div>
